__turbopack_context__.v({
  "markdown": "CategoryPageSliceZone-module-scss-module__twl84q__markdown",
  "slice": "CategoryPageSliceZone-module-scss-module__twl84q__slice",
});
